<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Deuda de Proveedores</strong>
          </div>
          <b-form>
            <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !proveedor,
                                  'fa fa-remove': proveedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="proveedor"
                  :value="proveedorNombre"
                  readonly
                  type="text"
                  :state="proveedorValido"/>
                <b-form-invalid-feedback id="proveedorFeedback">
                  {{ proveedorInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchProveedorModal"
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    // appRptButton: RptButtons,
    appSearchProveedor: SearchProveedor,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      proveedorValido: null,
      proveedorInvalidoMsj: '',

      proveedor: null,

      labelCols: 1,
    }
  },
  computed: {
    proveedorNombre() {
      return this.proveedor? this.proveedor.nombre.trim() : '';
    },
  },
  created() {
    
  },  
  methods: {
    validate() {

    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let proveedorId = 0;
      if (this.proveedor) {
        proveedorId = this.proveedor.id;
      }

      let params = {
        proveedorId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('cuentacorrienteproveedores/getRptDeuda', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let resumenDeudaRpt = this.$store.getters['cuentacorrienteproveedores/rptDeuda'];

            if (resumenDeudaRpt) {
              if (resumenDeudaRpt.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              this.exportXLSResumenDeudaProveedores(resumenDeudaRpt);
            } else {
              this.showErrorMsj('No hay datos para exportar.')
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goBack() {

    },
    seleccionarProveedor() {
      if (this.proveedor) {
        this.proveedor = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(item) {
      this.proveedor = item;
      this.$refs.searchProveedorModal.hide();
    },
  },
}
</script>

<style>
</style>
